var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(-0.409 0.365)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_39",
    "data-name": "Ellipse 39",
    cx: 17.5,
    cy: 18,
    rx: 17.5,
    ry: 18,
    transform: "translate(0.409 -0.365)",
    fill: "#1abc85"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_68",
    "data-name": "Layer 68",
    transform: "translate(6.895 8.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M24.122,5.106V9.529a1.106,1.106,0,1,1-2.212,0V7.892L15,15.788a1.137,1.137,0,0,1-1.648.044l-2.477-2.5L3.908,21.317a1.106,1.106,0,1,1-1.659-1.46L9.99,11.011a1.106,1.106,0,0,1,1.614-.055l2.565,2.477,6.27-7.221H18.593a1.106,1.106,0,0,1,0-2.212h4.423a1.106,1.106,0,0,1,1.106,1.106Z",
    transform: "translate(-1.941 -4)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIco);
export default __webpack_public_path__ + "static/media/profitIco.f2740229362aa051a3c859f6bff70ba2.svg";
export { ForwardRef as ReactComponent };